<div class="main-content">
    <div class="container-fluid">
        <mat-tab-group mat-align-tabs="center" mat-stretch-tabs="true" (selectedTabChange)="onTabChange($event)">
            <mat-tab label="Data View ">
                <div class="card">
                    <div class="card-header card-header-danger">
                        <h4 class="card-title">Search Bar Analysis</h4>
                    </div>

                    <div class="card-body">

                        <form [formGroup]="searchForm" (ngSubmit)="search()" class="form form-group">
                            <div class="row mt-4">
                                <div class="col-md-6">
                                    <label>Group By<span style="color: red !important;">*</span> </label>
                                    <ng-select [ngModel]="groupBy"
                                        [ngModelOptions]="{standalone: true}" (ngModelChange)="onGroupByChange($event)">
                                        <ng-option value="Monthly">Monthly</ng-option>
                                        <ng-option value="Yearly">Yearly</ng-option>
                                    </ng-select>
                                </div>
                                <div class="col-md-6">
                                    <label>Search By<span style="color: red !important;">*</span> </label>
                               
                                    

                                    <ng-container *ngIf="groupBy === 'Monthly'">
                                        <ng-select   [ngModel]="selectedMonthsDates"
                                        [ngModelOptions]="{standalone: true}" (ngModelChange)="onMonthsSelectionChange($event)" multiple="true">
                                        <ng-option *ngFor="let date of availableDatesMonthes" [value]="date"
                                        [disabled]="isMonthsDateDisabled(date)">{{ date | date: 'MMMM yyyy'
                                        }}</ng-option>
                                    </ng-select>
                                    </ng-container>

                               

                                    <ng-container *ngIf="groupBy === 'Yearly'" >
                                        <ng-select   [ngModel]="selectedYearsDates"
                                        [ngModelOptions]="{standalone: true}" (ngModelChange)="onYearsSelectionChange($event)" multiple="true">
                                        <ng-option *ngFor="let date of availableDatesYears" [value]="date"
                                        [disabled]="isYearssDateDisabled(date)">{{ date | date: 'yyyy'
                                        }}</ng-option>
                                    </ng-select>
                                    </ng-container>
                                    
                                </div>

                            </div>

                            <div class="row mt-4">
                                <div class="col-md-6">
                                    <label>Module <span style="color: red !important;">*</span></label>
                                    <ng-select [items]="clientmodule" [multiple]="false"
                                        bindLabel="name" bindValue="id" formControlName="moduleid"
                                        (change)="getcatbymodule(searchForm.get('moduleid').value)">
                                    </ng-select>
                                    <mat-error
                                        *ngIf="searchForm.get('moduleid').invalid && searchForm.get('moduleid').touched">
                                        Module Name is required
                                    </mat-error>
                                </div>

                                <div class="col-md-6">
                                    <label>Type <span style="color: red !important;">*</span> </label>
                                    <ng-select [items]="SearchType"
                                        (change)="onSearchTypeChange($event)" bindLabel="name" bindValue="id">

                                    </ng-select>
                                </div>
                            </div>

                            <div class="row mt-4">
                                <div class="col-md-6">
                                    <label>Branches<span style="color: red !important;">*</span></label>
                                    <ng-select  [items]="Branches" [multiple]="branchmulti"
                                        bindLabel="name" bindValue="id" formControlName="branches">
                                    </ng-select>
                                    <mat-error
                                        *ngIf="searchForm.get('branches').invalid && searchForm.get('branches').touched">
                                        Branches is required
                                    </mat-error>
                                </div>

                                <div class="col-md-6" *ngIf="categoryactive">
                                    <label>Category<span style="color: red !important;">*</span> </label>
                                    <ng-select  [items]="modulecat" [multiple]="false"
                                        bindLabel="name" bindValue="name" formControlName="categories"
                                        [(ngModel)]="selectedCategories">
                                    </ng-select>
                                </div>
                            </div>




                            <div class="row mt-4">
                                <div class="col-md-12">
                                    <button mat-raised-button type="submit" class="btn primary pull-right"
                                        [disabled]="searchForm.invalid">Search
                                    </button>
                                    <button mat-raised-button type="button" class="btn secondary pull-right ml-2"
                                        (click)="clear()">Clear
                                    </button>
                                </div>
                            </div>
                        </form>



                    </div>
                </div>


                <div class="card" *ngIf="SelectedSearchType === 1" [hidden]="!dataview">

                    <div class="card-header card-header-danger">
                        <h4 class="card-title">Audit Total Score</h4>
                    </div>
                    <div class="card-body">
                        <button type="button"  pButton pRipple icon="pi pi-download" (click)="exportChartAsImage(this.chartAnalysisAuditTotalScore)" class="mb-4 p-button-warning mr-2" pTooltip="image" tooltipPosition="bottom"></button>

                        <div class="row">
                            <div class="col-12">
                                <div class="m-4" style="height: 400px; overflow-x: auto;">
                                    <canvas id="AuditTotalScoreChart"></canvas>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card" *ngIf="SelectedSearchType === 2" [hidden]="!dataview">
                    <div class="card-header card-header-danger">
                        <h4 class="card-title"> Audit Detailed Score </h4>
                    </div>
                    <div class="card-body">
                        <button type="button"  pButton pRipple icon="pi pi-download" (click)="exportChartAsImage(this.chartAuditDetailedScore)" class="mb-4 p-button-warning mr-2" pTooltip="image" tooltipPosition="bottom"></button>

                        <div class="row">
                            <div class="col-12">
                                <div class="m-4" style="height: 400px; overflow-x: auto;">
                                    <canvas id="AuditDetailedScoreChart"></canvas>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card" *ngIf="SelectedSearchType === 3" [hidden]="!dataview">
                    <div class="card-header card-header-danger">
                        <h4 class="card-title">Department Kpi</h4>
                    </div>
                    <div class="card-body">
                        <button type="button"  pButton pRipple icon="pi pi-download" (click)="exportChartAsImage(this.chartDepartmentKpiScore)" class="mb-4 p-button-warning mr-2" pTooltip="image" tooltipPosition="bottom"></button>

                        <div class="row text-center">
                            <div class="col-12">
                                <div class="m-4" style="height: 400px; overflow-x: auto;">
                                    <canvas id="DepartmentKpiChart"></canvas>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card" *ngIf="SelectedSearchType === 4" [hidden]="!dataview">
                    <div class="card-header card-header-danger">
                        <h4 class="card-title">Task Compilation </h4>
                    </div>
                    <div class="card-body">
                        <button type="button"  pButton pRipple icon="pi pi-download" (click)="exportChartAsImage(this.chartTaskCompilationScore)" class="mb-4 p-button-warning mr-2" pTooltip="image" tooltipPosition="bottom"></button>

                        <div class="row">
                            <div class="col-12">

                                <div class="m-4" style="height: 400px; overflow-x: auto;">
                                    <canvas id="TaskCompilationChart"></canvas>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="card" *ngIf="SelectedSearchType === 5" [hidden]="!dataview">
                    <div class="card-header card-header-danger">
                        <h4 class="card-title">Santard Compilation</h4>
                    </div>
                    <div class="card-body">
                        <button type="button"  pButton pRipple icon="pi pi-download" (click)="exportChartAsImage(this.chartStandardCompilationScore)" class="mb-4 p-button-warning mr-2" pTooltip="image" tooltipPosition="bottom"></button>
                        <div class="row">
                            <div class="col-12">
                                <div class="m-4" style="height: 400px; overflow-x: auto;">
                                    <canvas id="StandardCompilationChart"></canvas>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>


                <div class="card" *ngIf="SelectedSearchType === 6" [hidden]="!dataview">
                    <div class="card-header card-header-danger">
                        <h4 class="card-title">Common Mistakes</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12">


                                <mat-accordion class="example-headers-align" multi="true">
                                    <mat-expansion-panel showToggle="false"
                                        *ngFor="let common of CommonMistakes; let i = index;">
                                        <mat-expansion-panel-header>
                                            {{common.date}}
                                        </mat-expansion-panel-header>
                                            <mat-accordion class="example-headers-align" multi="true">
                                                <mat-expansion-panel showToggle="false"
                                                    *ngFor="let cat of common.ques; let i = index;">
                                                    <mat-expansion-panel-header class="cat-text">
                                                        {{cat.catname}}
                                                    </mat-expansion-panel-header>
                                                    <mat-accordion class="example-headers-align" multi="true">
                                                        <mat-expansion-panel
                                                            *ngFor="let ques of cat.questions; let i = index;"
                                                            showToggle="false" class='mt-3'>
                                                            <mat-expansion-panel-header class='matHeaderForQues'>
                                                                <!-- <mat-panel-title>
                                                                    <span class="text-truncate"     
                                                                        style="max-width: 330px; border-radius: 5px; padding: 5px;">{{ques.englishname}}?</span>
                                                                </mat-panel-title> -->
                                                                <mat-panel-title class="row">
                                                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                                                            <span class="question-text p-2 rounded-md break-words w-full" >
                                                                                {{ques.englishname}}?
                                                                            </span>
                                                                        </div>
                                                                        <div class="col-lg-6 col-md-12 col-sm-12">
                                                                            <span class='pull-right'
                                                                            style="background-color: #c13e33; border-radius: 5px; padding: 5px; color: white; ">Score
                                                                            :{{ ques.percent | number:'1.2-2' }}%</span>
                                                                        </div>

                                                                  
                                                                </mat-panel-title>
                                                                <!-- <mat-panel-description>
                                                                
                                                                </mat-panel-description> -->
                                                            </mat-expansion-panel-header>
                                                            <div class="row">
                                                                <div class="col-4">
                                                                    <label>{{ques.comment}}</label>
                                                                </div>
                                                                <div class="col-8">
                                                                    <img style="height: 100px;"
                                                                        src="{{ques.photourl.url}}"
                                                                        class="img-thumbnail"
                                                                        (click)="openimage(ques.photourl.url)" />
                                                                </div>
                                                            </div>

                                                        </mat-expansion-panel>
                                                    </mat-accordion>
                                                </mat-expansion-panel>
                                            </mat-accordion>
                                    </mat-expansion-panel>
                                </mat-accordion>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="Data Compare">
                <div class="card">
                    <div class="card-header card-header-danger">
                        <h4 class="card-title">Search Bar Analysis</h4>
                    </div>
                    <div class="card-body">
                        <form [formGroup]="compareForm" (ngSubmit)="searchcompare()" class="row form form-group">
                                <div class="col-md-6 position-relative mt-4">
                                    <label>Group By<span style="color: red !important;">*</span> </label>
                                    <ng-select  [ngModel]="groupBy"
                                        [ngModelOptions]="{standalone: true}" (ngModelChange)="onGroupByChange($event)">
                                        <ng-option value="Monthly">Monthly</ng-option>
                                        <ng-option value="Yearly">Yearly</ng-option>
                                    </ng-select>
                                </div>
                                <div class="col-md-6 position-relative mt-4">
                                    <label class="form-label">Search By<span style="color: red !important;">*</span> </label>
                         


                                    <ng-container *ngIf="groupBy === 'Monthly'">
                                        <ng-select   [ngModel]="selectedMonthsDates"
                                        [ngModelOptions]="{standalone: true}" (ngModelChange)="CompareMonthsSelectionChange($event)" multiple="true">
                                        <ng-option *ngFor="let date of availableDatesMonthes" [value]="date">{{ date | date: 'MMMM yyyy'}}</ng-option>
                                    </ng-select>
                                    </ng-container>


              

                                    <ng-container *ngIf="groupBy === 'Yearly'" >
                                        <ng-select    [ngModel]="selectedYearsDates"
                                        [ngModelOptions]="{standalone: true}" (ngModelChange)="CompareYearsSelectionChange($event)" multiple="true">
                                        <ng-option *ngFor="let date of availableDatesYears" [value]="date"
                                        >{{ date | date: 'yyyy'
                                        }}</ng-option>
                                    </ng-select>
                                    </ng-container>


                                </div>


                                <div class="col-md-6 position-relative mt-4">
                                    <label class="form-label">Module <span style="color: red !important;">*</span></label>
                                    <ng-select  [items]="clientmodule" [multiple]="false"
                                        bindLabel="name" bindValue="id" formControlName="moduleid"
                                        (change)="getcatbymodule(compareForm.get('moduleid').value)">
                                    </ng-select>
                                    <mat-error
                                        *ngIf="searchForm.get('moduleid').invalid && searchForm.get('moduleid').touched">
                                        Module Name is required
                                    </mat-error>
                                </div>

                                <div class="col-md-6 position-relative mt-4">
                                    <label>Type <span style="color: red !important;">*</span> </label>
                                    <ng-select  [items]="filteredSearchType"
                                        (change)="onSearchTypeChange($event)" bindLabel="name" bindValue="id">
                                    </ng-select>
                                </div>

                                <div class="col-md-6 position-relative mt-4">
                                    <label class="form-label">Branches<span style="color: red !important;">*</span></label>
                                    <ng-select [items]="Branches" [multiple]="true"
                                        bindLabel="name" bindValue="id" formControlName="branches">
                                    </ng-select>
                                    <mat-error
                                        *ngIf="searchForm.get('branches').invalid && searchForm.get('branches').touched">
                                        Branches is required
                                    </mat-error>
                                </div>

                                <div class="col-md-6 position-relative mt-4" *ngIf="categoryactive">
                                    <label class="form-label">Category<span style="color: red !important;">*</span> </label>
                                    <ng-select  [items]="modulecat" [multiple]="false"
                                        bindLabel="name" bindValue="name" formControlName="categories"
                                        [(ngModel)]="selectedCategories">
                                    </ng-select>
                                </div>

                                <div class="col-md-12 position-relative mt-4">
                                    <button mat-raised-button type="submit" class="btn primary pull-right"
                                        >Search
                                    </button>
                                    <button mat-raised-button type="button" class="btn secondary pull-right ml-2"
                                        (click)="clear()">Clear
                                    </button>
                                </div>
                        </form>
                    </div>
                </div>

      

                 <!-- this for  audit total score & audit detailed score  -->

                 <div  class="card" *ngIf="(SelectedSearchType == 1 || SelectedSearchType == 2) && datacompare">
                    <p-table  #dt [value]="datatableaudittotalscore" [(selection)]="selectedCustomers" [exportHeader]="'customExportHeader'" 
                    [rowHover]="true"
                    [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
                   [paginator]="false" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                   [filterDelay]="0" [globalFilterFields]="filter">                  
                   <ng-template pTemplate="caption">
                       <div class="row">
                           <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel(dt)" class="mb-4 p-button-success mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
                           <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPDF(dt)" class="mb-4 p-button-warning mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
                         </div>
                         <div class="row">
                            <mat-form-field appearance="outline" class="search-field">
                                <mat-icon matPrefix>search</mat-icon>
                                <input matInput (input)="dt.filterGlobal($event.target.value, 'contains')" type="search" name="search" placeholder="Search...">
                              </mat-form-field>
                              <button type="button" pButton pRipple icon="pi pi-refresh" (click)="resetFilters(dt)" class="mb-4 p-button-secondary ml-2" pTooltip="Reset Filters" tooltipPosition="bottom"></button>
                         </div>
                   </ng-template>
                
                   <ng-template pTemplate="header">
                       <tr>
               <th *ngFor="let col of tableColumns" pSortableColumn="{{col.field}}" style="min-width: 5rem">
                   <div class="header-container">
                       <div class="header-title">{{col.displayName}}</div>
                       <div class="header-controls">
                           <p-sortIcon field="{{col.field}}"></p-sortIcon>
                           <p-columnFilter [type]="col.type" field="{{col.field}}" display="menu" class="ml-auto"></p-columnFilter>
                       </div>
                   </div>
               </th>
                       </tr>
                   </ng-template>
                   <ng-template pTemplate="body" let-customer>
                       <tr class="p-selectable-row">
   
                           <td *ngFor="let col of tableColumns">
                             <span class="p-column-title">{{col.displayName}}</span>
                             {{customer[col.field]}} 
                           </td>
                       </tr>
                   </ng-template>
                   <ng-template pTemplate="emptymessage">
                       <tr>
                           <td colspan="8">No data found.</td>
                       </tr>
                   </ng-template>
               </p-table>
    

                 </div>
           







                 <div  class="card" *ngIf="SelectedSearchType  == 3 && datacompare">
                    <p-table  #dp [value]="dataKpis" styleClass="p-datatable-gridlines"  [exportHeader]="'customExportHeader'" 
                    [rowHover]="true"
                    [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
                   [paginator]="false" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                   [filterDelay]="0" [globalFilterFields]="filterkpis">                  
                   <ng-template pTemplate="caption">
                       <div class="row">
                           <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcelkpi(dp)" class="mb-4 p-button-success mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
                           <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPDFKpi(dp)" class="mb-4 p-button-warning mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
             
                         </div>
                         <div class="row">
                            <mat-form-field appearance="outline" class="search-field">
                                <mat-icon matPrefix>search</mat-icon>
                                <input matInput (input)="dp.filterGlobal($event.target.value, 'contains')" type="search" name="search" placeholder="Search...">
                              </mat-form-field>
                               <button type="button" pButton pRipple icon="pi pi-refresh" (click)="resetFilters(dp)" class="mb-4 p-button-secondary ml-2" pTooltip="Reset Filters" tooltipPosition="bottom"></button>
                         </div>
                   </ng-template>
                   <ng-template pTemplate="header">
                    <tr>
                        <th  
                        pSortableColumn="branch" 
                        style="min-width: 6rem" rowspan="2"> 
                        <div class="header-container">
                            <div class="header-title">Branch</div>
                            <div class="header-controls">
                                <p-sortIcon field="branch"></p-sortIcon>
                                <p-columnFilter 
                                    type="text" 
                                    field="branch" 
                                    display="menu" 
                                    class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </div>
                    </th>
                    <th *ngFor="let col of kpiColumns"
                    [attr.colspan]="col.maxDepartments" 
                    style="min-width: 5rem">
                    <div class="header-title text-center">
                        {{col.displayName}}
                    </div>
                </th>
                    </tr>
                       <tr>      
                        <th *ngFor="let col of departmentColumns" 
                        pSortableColumn="{{col.colfield}}" 
                        style="min-width: 5rem"
                        [hidden]="col.colfield === 'branch'"> 
                        <div class="header-container">
                            <div class="header-title">{{col.display}}</div>
                            <div class="header-controls">
                                <p-sortIcon field="{{col.colfield}}"></p-sortIcon>
                                <p-columnFilter 
                                    [type]="getFilterType(col.colType)" 
                                    [field]="col.colfield" 
                                    display="menu" 
                                    class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </div>
                    </th>
                       </tr>
                   </ng-template>
                   <ng-template pTemplate="body" let-kpi >
                       <tr class="p-selectable-row">
                        <td *ngFor="let col of departmentColumns">
                            <span class="p-column-title">{{col.display|| 'N/A'}}</span>
                            {{kpi[col.colfield]}} 
                          </td>
                       </tr>
                   </ng-template>
                   <ng-template pTemplate="emptymessage">
                       <tr>
                           <td colspan="8">No data found.</td>
                       </tr>
                   </ng-template>
               </p-table>
                 </div>



                 <div  class="card" *ngIf="SelectedSearchType  == 4 && datacompare">
                    <p-table  #dtask [value]="taskCompilationCompare" styleClass="p-datatable-gridlines"  [exportHeader]="'customExportHeader'" 
                    [rowHover]="true"
                    [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
                   [paginator]="false" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                   [filterDelay]="0" [globalFilterFields]="filtertasks">                  
                   <ng-template pTemplate="caption">
                       <div class="row">
                           <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcelTasks(dtask)" class="mb-4 p-button-success mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
                           <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPDFTasks(dtask)" class="mb-4 p-button-warning mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
                 
                         </div>
                         <div class="row">
                            <mat-form-field appearance="outline" class="search-field">
                                <mat-icon matPrefix>search</mat-icon>
                                <input matInput (input)="dtask.filterGlobal($event.target.value, 'contains')" type="search" name="search" placeholder="Search...">
                              </mat-form-field>
                               <button type="button" pButton pRipple icon="pi pi-refresh" (click)="resetFilters(dtask)" class="mb-4 p-button-secondary ml-2" pTooltip="Reset Filters" tooltipPosition="bottom"></button>
                         </div>
                   </ng-template>
                   <ng-template pTemplate="header">
                    <tr>
                        <th  
                        pSortableColumn="branch" 
                        style="min-width: 6rem" rowspan="2"> 
                        <div class="header-container">
                            <div class="header-title">Branch</div>
                            <div class="header-controls">
                                <p-sortIcon field="branch"></p-sortIcon>
                                <p-columnFilter 
                                    type="text" 
                                    field="branch" 
                                    display="menu" 
                                    class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </div>
                    </th>
                    <th *ngFor="let col of monthsTaskCompilationcolumns"
                    colspan="2"
                    style="min-width: 5rem">
                    <div class="header-title text-center">
                        {{col.displayName}}
                    </div>
                </th>
                    </tr>
                       <tr>      
                        <th *ngFor="let col of monthsTaskCompilationopen_closecolumns" 
                        pSortableColumn="{{col.colfield}}" 
                        style="min-width: 5rem"
                        [hidden]="col.colfield === 'branch'"> 
                        <div class="header-container">
                            <div class="header-title">{{col.display}}</div>
                            <div class="header-controls">
                                <p-sortIcon field="{{col.colfield}}"></p-sortIcon>
                                <p-columnFilter 
                                    [type]="getFilterType(col.colType)" 
                                    [field]="col.colfield" 
                                    display="menu" 
                                    class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </div>
                    </th>
                       </tr>
                   </ng-template>
                   <ng-template pTemplate="body" let-task >
                       <tr class="p-selectable-row">
                        <td *ngFor="let col of monthsTaskCompilationopen_closecolumns">
                            <span class="p-column-title">{{col.display|| 'N/A'}}</span>
                            {{task[col.colfield]}} 
                          </td>
                       </tr>
                   </ng-template>
                   <ng-template pTemplate="emptymessage">
                       <tr>
                           <td colspan="8">No data found.</td>
                       </tr>
                   </ng-template>
               </p-table>
                 </div>




                 <div  class="card" *ngIf="SelectedSearchType  == 5 && datacompare">
                    <p-table  #dstandard [value]="StandardCompilationCompare" styleClass="p-datatable-gridlines"  [exportHeader]="'customExportHeader'" 
                    [rowHover]="true"
                    [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
                   [paginator]="false" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                   [filterDelay]="0" [globalFilterFields]="filterStandard">                  
                   <ng-template pTemplate="caption">
                       <div class="row">
                           <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcelStandards(dstandard)" class="mb-4 p-button-success mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
                           <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPDFStandards(dstandard)" class="mb-4 p-button-warning mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>

                         </div>
                         <div class="row">
                            <mat-form-field appearance="outline" class="search-field">
                                <mat-icon matPrefix>search</mat-icon>
                                <input matInput (input)="dstandard.filterGlobal($event.target.value, 'contains')" type="search" name="search" placeholder="Search...">
                              </mat-form-field>
                               <button type="button" pButton pRipple icon="pi pi-refresh" (click)="resetFilters(dstandard)" class="mb-4 p-button-secondary ml-2" pTooltip="Reset Filters" tooltipPosition="bottom"></button>
                         </div>

                   </ng-template>
                   <ng-template pTemplate="header">
                    <tr>
                        <th  
                        pSortableColumn="branch" 
                        style="min-width: 6rem" rowspan="2"> 
                        <div class="header-container">
                            <div class="header-title">Branch</div>
                            <div class="header-controls">
                                <p-sortIcon field="branch"></p-sortIcon>
                                <p-columnFilter 
                                    type="text" 
                                    field="branch" 
                                    display="menu" 
                                    class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </div>
                    </th>
                    <th *ngFor="let col of monthsStandardCompilationcolumns"
                    colspan="3"
                    style="min-width: 5rem">
                    <div class="header-title text-center">
                        {{col.displayName}}
                    </div>
                </th>
                    </tr>
                       <tr>      
                        <th *ngFor="let col of monthsStandardCompilationopen_closecolumns" 
                        pSortableColumn="{{col.colfield}}" 
                        style="min-width: 5rem"
                        [hidden]="col.colfield === 'branch'"> 
                        <div class="header-container">
                            <div class="header-title">{{col.display}}</div>
                            <div class="header-controls">
                                <p-sortIcon field="{{col.colfield}}"></p-sortIcon>
                                <p-columnFilter 
                                    [type]="getFilterType(col.colType)" 
                                    [field]="col.colfield" 
                                    display="menu" 
                                    class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </div>
                    </th>
                       </tr>
                   </ng-template>
                   <ng-template pTemplate="body" let-standard >
                       <tr class="p-selectable-row">
                        <td *ngFor="let col of monthsStandardCompilationopen_closecolumns">
                            <span class="p-column-title">{{col.display|| 'N/A'}}</span>
                            {{standard[col.colfield]}} 
                          </td>
                       </tr>
                   </ng-template>
                   <ng-template pTemplate="emptymessage">
                       <tr>
                           <td colspan="8">No data found.</td>
                       </tr>
                   </ng-template>
               </p-table>
                 </div>

            </mat-tab>
        </mat-tab-group>
    </div>
</div>